<template>
    <b-table
            id="cdasExecoes"
            :items="resultado"
            :fields="fields"
            striped
            small
            responsive="sm"
            :no-local-sorting="true"
            @sort-changed="sortingChanged"
            :busy="configTable.load"
            show-empty
    >
        <template #table-busy>
            <div class="text-center text-primary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong> Carregando...</strong>
            </div>
        </template>

        <template #empty>
            <p class="my-auto">Nenhum registro encontrado.</p>
        </template>

        <template #HEAD_selecionar>
            <b-form-checkbox v-model="configTable.checkedAll" class="mx-auto justify-content-center text-center ml-1" @change="toggleAll" />
        </template>
        <template #selecionar="row">
            <template>
                <b-form-checkbox class="mx-auto justify-content-center text-center" :checked="row.item.checked" @change="toggleCheck($event, row.item, null, true)" />
            </template>
        </template>

        <template #1="row">
            <p class="text-left" :style="'min-width: 165px'">
                {{ row.item.tipoEvento.nome }}
            </p>
        </template>
        <template #2="row">
            <p class="text-left" :style="'min-width: 70px'">
                {{ row.item.numeroDivida }}
            </p>
        </template>
        <template #3="row">
            <p class="text-left" :style="'min-width: 70px'">
                {{ row.item.orgaoOrigem }}
            </p>
        </template>
        <template #4="row">
            <p class="text-left" :style="'min-width: 90px'">
                {{ row.item.numeroCnpjRaiz }}
            </p>
        </template>
        <template #5="row">
            <p class="text-left" :style="{'min-width': '80px','white-space': 'nowrap'}">
                {{ row.item.numeroCnpj }}
            </p>
        </template>
        <template #6="row">
            <p class="text-left" :style="'min-width: 80px'">
                {{ row.item.numeroCpf }}
            </p>
        </template>
        <template #7="row">
            <p class="text-left" :style="'min-width: 100px'">
                {{ row.item.nomeUsuarioInclusao || '-' }}
            </p>
        </template>
        <template #8="row">
            <p class="text-left" v-if="row.item.dataHoraInclusao !== '2000-01-01 00:01:01.000'" :style="'min-width: 105px'">
                {{ formatarDataHora(row.item.dataHoraInclusao) }}
            </p>
            <p v-else :style="'min-width: 105px'">-</p>
        </template>
        <template #9="row">
            <p class="text-left" v-if="row.item.dataHoraInativacao !== '2000-01-01 00:01:01.000'" :style="'min-width: 105px'">
                {{ formatarDataHora(row.item.dataHoraInativacao) }}
            </p>
            <p v-else :style="'min-width: 120px'">-</p>
        </template>
        <template #10="row">
            <p class="text-center" v-if="row.item.prazo !== null && row.item.prazo !== ''" :style="'min-width: 105px'">
                {{ row.item.prazo }}
            </p>
            <p v-else :style="'min-width: 105px'">-</p>
        </template>        
        <template #11="row">
            <p class="text-left" :style="'min-width: 90px'">
                {{ row.item.motivo }}
            </p>
        </template>
        <template #12="row">
            <p class="text-center" :style="'min-width: 90px'">
                {{ row.item.indAtivo ? 'Ativo' : 'Inativo' }}
            </p>
        </template>
    </b-table>
</template>

<script>
import formatarMixins from '../../mixins/formatarMixins'
    export default {
        mixins: [ formatarMixins ],
        props: ['resultado', 'fields', 'configTable','selecteds'],
        watch: {
            currentPage() {
                this.configTable.checkedAll = false
                this.$emit('consultar')
            }
        },
        computed: {
            currentPage() {
                return this.configTable.currentPage
            }
        },
        methods: {
            sortingChanged(ctx) {
                const sortMap = {
                    1: 'tipoEvento',
                    2: 'numeroDivida',
                    3: 'orgaoOrigem',
                    4: 'numeroCnpjRaiz',
                    5: 'numeroCnpj',
                    6: 'numeroCpf',
                    7: 'nomeUsuarioInclusao',
                    8: 'dataHoraInclusao',
                    9: 'dataHoraInativacao',
                    10: 'prazo',
                    11: 'motivo',
                    12: 'indAtivo'
                };
                this.configTable.sortField = sortMap[ctx.sortBy] || null;
                this.configTable.sortOrder = ctx.sortDesc ? 'desc' : 'asc';
                this.$emit('sortingChanged')
            },
            toggleAll(checked) {
                if(checked) {
                    this.resultado.forEach(el => {
                        el.checked = true;
                    if(!this.selecteds.includes(el.codExcecaoDevedor)) {
                        this.selecteds.push(el.codExcecaoDevedor);
                    }
                })
                } else {
                    this.resultado.forEach(el => {
                        el.checked = false;
                    if(this.selecteds.includes(el.codExcecaoDevedor)) {
                        const index = this.selecteds.indexOf(el.codExcecaoDevedor);
                        this.selecteds.splice(index, 1);
                    }
                })
                }
            },
            toggleCheck(checked, item) {
                if(checked) {
                    item.checked = checked;
                    this.selecteds.push(item.codExcecaoDevedor);
                } else {
                    item.checked = checked;
                    const index = this.selecteds.indexOf(item.codExcecaoDevedor);
                    this.selecteds.splice(index, 1);
                    this.configTable.checkedAll = false;
                }

            }
        }
    }
</script>

<style>
    th {
        text-align: center !important;
    }
</style>
